import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { siteData } from '../mock/data';
import ScrollReveal, { ImageReveal } from '../components/ScrollReveal';
import ContactBlock from '../components/ContactBlock';
import { Link } from 'react-router-dom';

const Services = () => {
  const { services } = siteData;
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 200);
    }
  }, [hash]);

  return (
    <>
      {/* HERO */}
      <section className="pt-40 pb-24">
        <div className="container-x">
          <div className="font-mono-up text-[#0A2A28]/60 mb-8 hero-eyebrow">
            <span className="gold-line" />{services.eyebrow}
          </div>
          <h1 className="font-display text-[13vw] md:text-[9vw] leading-[0.9] text-[#0A2A28] -tracking-[0.02em]">
            <span className="hero-title block">{services.title}</span>
            <span className="hero-title-2 block font-serif-italic text-[#BFA070]">{services.titleAccent}</span>
          </h1>
          <div className="grid md:grid-cols-12 gap-10 mt-14 hero-para">
            <div className="md:col-span-6 md:col-start-6">
              <p className="text-[#0A2A28]/80 text-lg leading-relaxed mb-5">{services.intro}</p>
              <p className="text-[#0A2A28]/70 leading-relaxed">{services.intro2}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Service list alternating */}
      {services.list.map((s, i) => {
        const reverse = i % 2 === 1;
        const isDark = i === 2 || i === 4;
        return (
          <section
            key={s.id}
            id={s.id}
            className={`section-sm ${isDark ? 'dark-section radial-glow' : i % 2 === 0 ? 'bg-[#F5F1EA]' : 'bg-[#EFE9DE]'}`}
          >
            <div className="container-x">
              <div className={`grid md:grid-cols-12 gap-14 items-center ${reverse ? 'md:[&>div:first-child]:order-2' : ''}`}>
                <div className="md:col-span-6">
                  <ImageReveal src={s.image} alt={s.title} className="aspect-[4/5]" />
                </div>
                <div className="md:col-span-6">
                  <ScrollReveal>
                    <div className={`font-mono-up mb-6 ${isDark ? 'text-[#BFA070]' : 'text-[#0A2A28]/60'}`}>
                      <span className="gold-line" />Leistung / {s.number}
                    </div>
                  </ScrollReveal>
                  <ScrollReveal delay={1}>
                    <h2 className={`font-display text-5xl md:text-6xl leading-[0.98] mb-8 ${isDark ? 'text-[#E8E2D5]' : 'text-[#0A2A28]'}`}>
                      {s.title.split(' ').map((w, idx, arr) => (
                        <React.Fragment key={idx}>
                          {idx === arr.length - 1 ? <span className="font-serif-italic text-[#BFA070]">{w}</span> : <>{w} </>}
                        </React.Fragment>
                      ))}
                    </h2>
                  </ScrollReveal>
                  <ScrollReveal delay={2}>
                    <p className={`text-lg leading-relaxed mb-8 ${isDark ? 'text-[#E8E2D5]/80' : 'text-[#0A2A28]/75'}`}>
                      {s.text}
                    </p>
                  </ScrollReveal>
                  <ScrollReveal delay={3}>
                    <Link to="/kontakt" className={`lux-btn ${isDark ? 'lux-btn-light' : ''}`}>
                      <span>Beratung anfragen</span>
                      <ArrowUpRight className="arrow" size={16} strokeWidth={1.5} />
                    </Link>
                  </ScrollReveal>
                </div>
              </div>
            </div>
          </section>
        );
      })}

      {/* CTA to objekte */}
      <section className="section bg-[#EFE9DE]">
        <div className="container-x text-center">
          <ScrollReveal>
            <div className="font-mono-up text-[#0A2A28]/60 mb-6">Objekte & Referenzen</div>
          </ScrollReveal>
          <ScrollReveal delay={1}>
            <h2 className="font-display text-6xl md:text-8xl leading-[0.95] text-[#0A2A28] mb-8">
              Bestände mit <span className="font-serif-italic text-[#BFA070]">Perspektive.</span>
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={2}>
            <p className="max-w-2xl mx-auto text-[#0A2A28]/75 text-lg leading-relaxed mb-10">
              Aurelian Heights betreut Luxusimmobilien, die verantwortungsvoll gesteuert und nachhaltig entwickelt werden.
            </p>
          </ScrollReveal>
          <ScrollReveal delay={3}>
            <Link to="/objekte" className="lux-btn">
              <span>Mehr erfahren</span>
              <ArrowUpRight className="arrow" size={16} strokeWidth={1.5} />
            </Link>
          </ScrollReveal>
        </div>
      </section>

      <ContactBlock />
    </>
  );
};

export default Services;
